import { MetricDetails } from '../../../../api/metrics/types';
import { SQLFilters } from '../../../../api/types';
import { MetricId } from '../../../../api/types-graphql';
import {
  GroupBy,
  MetricIdType,
  SingleValueTimeSelection,
} from '../../../../types';
import { LanguageString } from '../../dashboards/types';
import { TitleConfig } from '../../ui-components/data-viz-ui/charts/common/common-chart-types';
import {
  ExternalChartComponentProps,
  KpiBenchmarkConfig,
  UnsegmentedGroupVal,
} from '../common/types';

export enum TimePeriodUnsegmentedVizViews {
  BAR_CHART = 'bar-chart',
  PIE_CHART = 'pie-chart',
}

export interface TimePeriodUnsegmentedVizExternalProps
  extends ExternalChartComponentProps {
  selectedView: TimePeriodUnsegmentedVizViews;
}

interface TimePeriodUnsegmentedVizQuery {
  metric: MetricIdType;
}

export interface TimePeriodUnsegmentedVizConfig {
  title?: LanguageString;
  /**
   * Optional disclaimer/caption rendered next to the title via the chart's
   * `extraContent` slot (e.g. "※最新のデータ更新月時点").
   */
  subtitle?: LanguageString;
  /**
   * Optional footer caption shown **below** the chart (pie only today). Same
   * shape as KPI factbox `footer` / `LanguageString`.
   */
  footer?: LanguageString;
  /**
   * KPI factbox–style benchmarks: extra metric queries with
   * `getKpiFactboxBenchmarkTimeSelection` and per–`groupBy` slice rows under
   * the **pie** chart only (`TimePeriodUnsegmentedVizViews.PIE_CHART`).
   */
  benchmarkConfigs?: KpiBenchmarkConfig[];
  timeSelection: SingleValueTimeSelection;
  groupBy: GroupBy;
  queries: TimePeriodUnsegmentedVizQuery[];
  filters?: SQLFilters;
  chartColors?: string[];
}

export type TimePeriodUnsegmentedVizDataResponse = {
  groupBy: GroupBy;
  responseForMetrics: {
    metric: MetricIdType;
    groups: UnsegmentedGroupVal[];
    metricSql: string | null;
  }[];
};

export type TimePeriodPieBenchmarkSubRow = {
  title: string;
  value: string;
};

export type TimePeriodUnsegmentedVizData = {
  dataResponse: TimePeriodUnsegmentedVizDataResponse;
  titleConfig: TitleConfig;
  metricDisplayValues: Partial<Record<MetricId, string>>;
  metricDetails: Partial<Record<MetricId, MetricDetails>>;
  chartColors?: string[];
  /** Populated for pie + `benchmarkConfigs` when benchmark queries succeed. */
  pieBenchmarkSubRows?: TimePeriodPieBenchmarkSubRow[];
  /** Localized `config.footer` for pie (and reserved for future bar use). */
  pieFooter?: string;
};
